import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import PageTitle from 'components/atoms/PageTitle'
import LogisticsContent from 'components/organisms/Logistics'

import {
  ROLES_ARVAL,
  ROLE_B2C,
  ROLE_POST_SALES,
  ROLE_READ_ONLY,
  useAuth,
} from '../../auth'

export default function Logistics() {
  const { t } = useTranslation()
  const { hasOneOfRoles } = useAuth()
  const userRoleHasReadOnly = useMemo(
    () => hasOneOfRoles([ROLE_READ_ONLY, ROLE_B2C, ROLE_POST_SALES]),
    [hasOneOfRoles]
  )

  const canAccess = useMemo(() => hasOneOfRoles(ROLES_ARVAL), [hasOneOfRoles])

  if (!canAccess) {
    return <Navigate to="/agenda" />
  }

  return (
    <div className="content-container">
      <PageTitle label={t('logistics.title')} />
      <LogisticsContent contentIsReadOnly={userRoleHasReadOnly} />
    </div>
  )
}
